import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './components/Auth';
import { AlertProvider } from './components/Alert';

ReactDOM.render(
	<AuthProvider>
		<AlertProvider>
			<App />
		</AlertProvider>
	</AuthProvider>,
	document.getElementById('root')
);
